exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".remote-level .ant-table-wrapper {\n  margin: 20px auto;\n  width: 600px;\n}\n.remote-level .ant-table-wrapper table {\n  border: 1px solid #e5e5e5;\n  text-align: center;\n}\n.remote-level .ant-table-placeholder {\n  border-left: 1px solid #e5e5e5;\n  border-right: 1px solid #e5e5e5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/remote/version/index.less
// module id = 1515
// module chunks = 0